import FJAIVideoGeneratorLeftContainer from './FJAIVideoGeneratorLeft/container/FJAIVideoGeneratorLeftContainer.jsx';
import FJAIVideoGeneratorRightContainer from './FJAIVideoGeneratorRight/container/FJAIVideoGeneratorRightContainer.jsx';
import { useEffect } from 'react';
import FJUtil from '../../util/FJUtil.js';

function FJAIVideoGenerator() {
    // ab测试的统计
    useEffect(() => {
        if (!window.isEditPage) {
            const type =
                FJUtil.isLocalhost() || window?.fjuser?.info?.id % 2 === 0 ? 'text to video' : 'image to video';
            FJUtil.eaLog('ai videos generate page vist ABtest', { type: type });
        }
    }, []);

    return (
        <>
            <FJAIVideoGeneratorLeftContainer />
            <FJAIVideoGeneratorRightContainer />
        </>
    );
}

export default FJAIVideoGenerator;
